import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  // Validate inputData if provided
  if (properties.inputData) {
    try {
      JSON.parse(properties.inputData);
    } catch (e) {
      errors.push({ key: 'inputData', message: 'Input data must be valid JSON' });
    }
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
